import { Component, inject, OnInit } from '@angular/core';

import { Theme, ThemeService, ThemeType } from '@app/shell/services/theme.service';
import { IconComponent } from '@shared/components/ui';

@Component({
  selector: 'app-theme-switch',
  imports: [IconComponent],
  template: `
    <div class="theme-switch">
      <app-icon iconName="sun" marginRight="2px"></app-icon>
      <input (change)="themeChange($event)" [checked]="currentTheme === 'dark'" class="toggle-btn" type="checkbox" />
      <app-icon iconName="moon"></app-icon>
    </div>
  `,
  styles: `
    .theme-switch {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      gap: 6px;
    }
  `,
})
export class ThemeSwitchComponent implements OnInit {
  currentTheme: ThemeType = Theme.Light;
  private readonly _themeService = inject(ThemeService);

  ngOnInit() {
    this.currentTheme = this._themeService.currentTheme;
  }

  themeChange(event: Event) {
    this.currentTheme = (event.target as HTMLInputElement).checked ? Theme.Dark : Theme.Light;
    this._themeService.currentTheme = this.currentTheme;
  }
}
